import script from "./QuickCreateVideoFrom.vue?vue&type=script&setup=true&lang=js"
export * from "./QuickCreateVideoFrom.vue?vue&type=script&setup=true&lang=js"

import "./QuickCreateVideoFrom.vue?vue&type=style&index=0&id=276f526f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-276f526f"]])

export default __exports__